<template>
    <v-navigation-drawer
        temporary
        :right="left"
        v-model="show"
        fixed
        app
    >
        <v-list>
            <v-list-tile>
                <v-list-tile-action>
                    <v-icon>compare_arrows</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Switch drawer (click me)</v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    export default {
        name: "Start",
        props: {
            show: {
                default: true
            }
        },
        beforeMount () {
            console.log("aqui");
        }
    };
</script>

<style scoped>

</style>
